export default __webpack_public_path__ + "static/media/Clientes_Formato_de_aclaraciones.9a0942b0.xlsx";